export const createElement = (type, config, children = []) => {
  const element = document.createElement(type);
  // eslint-disable-next-line no-restricted-syntax
  for (const name in config) {
    // eslint-disable-next-line no-prototype-builtins
    if (name && config.hasOwnProperty(name)) {
      const value = config[name];
      if (value === true) {
        element.setAttribute(name, name);
      } else if (value !== false && value != null) {
        element.setAttribute(name, value.toString());
      }
    }
  }
  const childs = Array.isArray(children) ? children : [children];
  // eslint-disable-next-line no-restricted-syntax
  for (const child of childs) {
    element.appendChild(
      child.nodeType == null
        ? document.createTextNode(child.toString()) : child,
    );
  }
  return element;
};

export const installComponent = (name, component) => customElements.get(name) || customElements.define(name, component);
